import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import {Tabs, Transfer} from 'antd';
// import elements
import TagList from '../elements/Component.TagList';

const TabPane = Tabs.TabPane;

/**
 * @param {object} state
 * @param {array} state.variableData - array of objects, complete data for rendering UI
 * @param {object} state.variableKeys - simple array, selected items
 * @param {object} state.fixedData - array of objects, complete data for rendering UI
 * @param {object} state.fixedKeys  - simple array, selected items
 */

class ModificationTab extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      variableData: [], // [{key: "", title: "", description: "", chosen: false}]
      variableKeys: [], // ["", ""]
      fixedData: [], // [{key: "", title: "", description: "", chosen: false}]
      fixedKeys: [], // ["", ""]
    }
  }
  
  componentDidMount(){
    // console.log("modification component did mount");
    const {variableModifications, fixedModifications, parameters} = this.props;
    let _variableModObj = getVariableData(variableModifications, parameters.varied);
    let _fixedModObj = getFixedData(fixedModifications, parameters.fixed);

    // console.log(_variableModObj);
    // console.log(_fixedModObj);

    this.setState({..._variableModObj, ..._fixedModObj});
  }

  filterOption = (inputValue, option) => {
    return option.description.indexOf(inputValue) > -1;
  }

  handleVariableChange = (variableKeys) => {
    this.setState({variableKeys});

    // ***
    // update parameters to parent
    let _parameters = JSON.parse(JSON.stringify(this.props.parameters));
    _parameters.varied = [...variableKeys];
    this.props.updateParameters(_parameters);
  }

  handleFixedChange = (fixedKeys) => {
    this.setState({fixedKeys});

    // ***
    // update parameters to parent
    let _parameters = JSON.parse(JSON.stringify(this.props.parameters));
    _parameters.fixed = [...fixedKeys];
    this.props.updateParameters(_parameters);
  }

  callback(key){
    //console.log(key);
  }

  render(){
    // console.log("rendering...");
    // console.log(this.state);
    // console.log(this.props);

    return (
      <div>
        <div className="parameters-subcategory-title-wrapper">
          <div>Set Modifications</div>
        </div>
        <Tabs defaultActiveKey="1" onChange={this.callback}>

          <TabPane tab="Variable Modifications" key="1">
            <Transfer
              listStyle={{
                width: '45%',
                height: 400,
              }}
              dataSource={this.state.variableData}
              showSearch
              filterOption={this.filterOption}
              targetKeys={this.state.variableKeys}
              onChange={this.handleVariableChange}
              render={item=>item.title}>
            </Transfer>

            <TagList 
              color = "#108ee9"
              list = {this.state.variableKeys}
              title = "Selected variable modifications: "
            />
          </TabPane>

          <TabPane tab="Fixed Modifications" key="2">
            <Transfer
              listStyle={{
                width: '45%',
                height: 400,
              }}
              dataSource={this.state.fixedData}
              showSearch
              filterOption={this.filterOption}
              targetKeys={this.state.fixedKeys}
              onChange={this.handleFixedChange}
              render={item=>item.title}>
            </Transfer>
    
            <TagList 
              color = "#108ee9"
              list = {this.state.fixedKeys}
              title = "Selected fixed modifications: "
            />
          </TabPane>

        </Tabs>
      </div>
    );
  }
}

export default ModificationTab;

ModificationTab.defaultProps = {
  variableModifications: [],
  fixedModifications: [],
  parameters: {
    varied: [],
    fixed: []
  }
}

// ***
// @param {array} variableModifications - [{"variable modification":""}, {"variable modification":""}]
// @param {array} defaultKeys - ["", ""]
const getVariableData = (variableModifications, defaultKeys) => {

  const variableKeys = [];
  const variableData = [];

  for (let i = 0; i < variableModifications.length; i++){
    const data = {
      key: `${variableModifications[i]["variable modification"]}`,
      title: `${variableModifications[i]["variable modification"]}`,
      description: `description of content${variableModifications[i]["variable modification"]}`,
      chosen: defaultKeys.indexOf(variableModifications[i]["variable modification"]) > -1
    };
    if(data.chosen){ variableKeys.push(data.key); }
    variableData.push(data);
  }
  return {variableData, variableKeys};
}

const getFixedData = (fixedModifications, defaultKeys) => {

  const fixedKeys = [];
  const fixedData = [];

  for (let i = 0; i < fixedModifications.length; i++){
    const data = {
      key: `${fixedModifications[i]["fixed modification"]}`,
      title: `${fixedModifications[i]["fixed modification"]}`,
      description: `description of content ${fixedModifications[i]["fixed modification"]}`,
      chosen: defaultKeys.indexOf(fixedModifications[i]["fixed modification"]) > -1
    };
    if(data.chosen){fixedKeys.push(data.key);}
    fixedData.push(data);
  }
  return {fixedData, fixedKeys}
}


